<template>
  <Page :title="title">
    <div class="client-number">
      <div class="table-header">
        <div class="table-header-item" @click="selectTime">
          {{ dateFilterSelect }}
          <img
            :src="require('@/assets/img/uparrow.png')"
            class="uparrow"
            alt
            srcset
          />
        </div>
        <div class="table-header-item">组次合计：{{ groupAll || 0 }}</div>
        <div class="table-header-item">总客流：{{ passengerAll || 0 }}</div>
      </div>
      <table border="1" cellspacing="0" class="table-all">
        <tr>
          <th colspan="2">日期</th>
          <th>组数</th>
          <th>人数</th>
        </tr>
        <tr v-for="(item, index) in list" v-bind:key="index">
          <td>{{ item.visitDate }}</td>
          <td>{{ item.week }}</td>
          <td @click="groups_(index)">
            <input
              :readonly="!hasCreated"
              type="number"
              class="input-list"
              v-model="item.group"
              @keyup="inputBlur_(index, 1)"
            />
          </td>
          <td @click="numbers_(index)">
            <input
              :readonly="!hasCreated"
              type="number"
              class="input-list"
              v-model="item.visitCnt"
              @keyup="inputBlur_(index, 2)"
            />
          </td>
        </tr>
      </table>
      <!-- 筛选 -->
      <van-popup v-model="timeShow" position="bottom" :overlay="true">
        <van-picker
          show-toolbar
          title=""
          :columns="dateFiltrates"
          @cancel="onCancelTime"
          @confirm="onConfirmTime"
          class="van-picker-li"
        />
      </van-popup>
    </div>
  </Page>
</template>




<script>
import {
  lastDayOfWeek,
  startOfWeek,
  startOfMonth,
  endOfMonth,
  getTime,
  addWeeks,
  addMonths,
} from "date-fns";
export default {
  data() {
    return {
      title: "到店人数",
      list: [],
      dateFiltrates: ["本周", "本月", "上周", "上月"],
      dateFilterSelect: "本周",
      timeShow: false,
      lastDayOfWeek: this.$time(
        lastDayOfWeek(new Date(new Date()), { weekStartsOn: 1 })
      ), //本周最后一天
      startOfWeek: this.$time(
        startOfWeek(new Date(new Date()), { weekStartsOn: 1 })
      ), //本周第一天
      startOfMonth: this.$time(startOfMonth(new Date(new Date()))), //本月第一天
      endOfMonth: this.$time(endOfMonth(new Date(new Date()))), //本月最后一天
      endOfLastWeek: this.$time(
        lastDayOfWeek(addWeeks(new Date(), -1), { weekStartsOn: 1 })
      ), //上周最后一天
      startOfLastWeek: this.$time(
        startOfWeek(addWeeks(new Date(), -1), { weekStartsOn: 1 })
      ), //上周第一天
      startOfLastMonth: this.$time(startOfMonth(addMonths(new Date(), -1))), //上月第一天
      endOfLastMonth: this.$time(endOfMonth(addMonths(new Date(), -1))), //上月最后一天
      passengerAll: 0, //客流总数
      groupAll: 0, //组数总数
      saveList: [], //提交数组
      hasCreated: true, //是否有创建权限
    };
  },
  methods: {
    /**
     *  @param {Number}  Index  当前点击 td 索引
     */
    groups_(Index) {
      console.log("当前索引", Index);
      // var $list =[];
      //     $list =this.list;
      //     $list[Index]['editA']=true;
      //     this.list=$list;
      //     this.$refs.input1.focus()
    },
    numbers_(Index) {
      //    console.log("当前索引",Index)
    },
    /**
     *  @param {Number}  Index  失去焦点 判断当前input值
     */
    inputBlur_(Index, ID) {
      this.saveList = [];
      if (ID == 1) {
        this.saveList.push(this.list[Index]);
        console.log(this.saveList, "ssssss");

        this.saveSaleslist();
      } else {
        this.saveList.push(this.list[Index]);
        this.saveSaleslist();
        console.log(this.saveList, "aaaaaa");
      }
    },
    onCancelTime() {
      this.timeShow = false;
    },
    onConfirmTime(val) {
      this.dateFilterSelect = val;
      switch (val) {
        case "本月":
          this.getSalesDetail(this.startOfMonth, this.endOfMonth);
          break;
        case "上周":
          this.getSalesDetail(this.startOfLastWeek, this.endOfLastWeek);
          break;
        case "上月":
          this.getSalesDetail(this.startOfLastMonth, this.endOfLastMonth);
          break;
        case "本周":
        default:
          this.getSalesDetail(this.startOfWeek, this.lastDayOfWeek);
          break;
      }
      this.timeShow = false;
    },
    selectTime() {
      this.timeShow = true;
    },
    /**
     *
     *  获取每日客流
     *  @param {String}  salesId    销售用户ID
     *  @param {String}  startDate  开始日期
     *  @param {String}  endDate    结束日期
     *
     *
     */
    getSalesDetail(startDate, endDate) {
      this.$api
        .getSalesDetail({
          salesId: this.$wxuserUtil.getUserId(),
          startDate: startDate,
          endDate: endDate,
        })
        .then((Response) => {
          if (Array.isArray(Response.data)) {
            for (let i = 0; i < Response.data.length; i++) {
              Response.data[i]["week"] = this.dateChangeWeek(
                Response.data[i]["visitDate"]
              );
              Response.data[i]["date"] = getTime(
                new Date(Response.data[i]["visitDate"])
              );
              Response.data[i]["id"] = Response.data[i]["U_StoreVisitId"];
              Response.data[i]["visitCnt"] = Response.data[i]["U_VisitCnt"];
              Response.data[i]["group"] = Response.data[i]["U_GroupNum"];
            }
            this.passengerAll = this.total(Response.data, 0); //客流总数
            this.groupAll = this.total(Response.data, 1); //组数总数
            this.list = Response.data;
          }
        });
    },
    /**
     *
     *  提交每日客流
     *  @param {Object}   Body    提交字符串对象
     *  @param {String}  salesId    销售用户ID
     *
     */
    saveSaleslist() {
      let data = {
        salesId: this.$wxuserUtil.getUserId(),
        list: this.saveList,
      };
      this.$api.saveSaleslist(data).then((Response) => {
        console.log("提交返回", Response);
      });
    },
    /**
     *  日期转星期
     *  @param {String}  DATE   xxxx-xx-xx
     */
    dateChangeWeek(DATE) {
      var day = new Date(DATE).getDay(),
        text = "";
      switch (day) {
        case 0:
          text = "星期日";
          break;
        case 1:
          text = "星期一";
          break;
        case 2:
          text = "星期二";
          break;
        case 3:
          text = "星期三";
          break;
        case 4:
          text = "星期四";
          break;
        case 5:
          text = "星期五";
          break;
        case 6:
          text = "星期六";
          break;
      }
      return text;
    },
    /**
     *  客流 组数 合计
     *  @param {Array}  list
     *  @param {String} ID   判断 客流 0 组数 1
     */
    total(list, ID) {
      let all = 0;
      if (Array.isArray(list)) {
        for (let i = 0; i < list.length; i++) {
          if (ID == 0) {
            all += list[i]["U_VisitCnt"];
          } else {
            all += list[i]["U_GroupNum"];
          }
        }
        return all;
      } else {
        return all;
      }
    },
  },
  mounted() {
    this.hasCreated = this.$wxuserUtil.hasFunAuthByRouteInst(
      this.$route,
      this.$funcKey.Created
    );
    this.getSalesDetail(this.startOfWeek, this.lastDayOfWeek);
  },
  watch: {},
  created() {},
};
</script>


//
<style lang="less" scoped>
.client-number {
  font-size: 0.4rem;
  .table-all {
    width: 100%;
    border: 1px solid #b2b2b2;
    border-collapse: collapse;
    margin-top: 1rem;
  }
  th,
  td {
    border: 1px solid #b2b2b2;
    text-align: center;
    height: 1rem;
  }
  tbody {
    width: 100%;
    height: auto;
  }
  .input-list {
    width: 2rem;
    border: none;
    outline: none;
    background: rgb(244, 244, 244);
    margin: 0 auto;
    text-align: center;
  }
  .table-header {
    height: 1rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    -ms-flex-item-align: center;
    align-items: center;
    background: #cbc7c7;
    color: #000;
    position: fixed;
    top: 0rem;
    left: 0rem;
    .table-header-item {
      text-align: center;
      flex: 1;
      position: relative;
      .uparrow {
        position: absolute;
        right: 0.5rem;
        top: 50%;
        width: 0.3rem;
        height: 0.3rem;
        margin-top: -0.15rem;
      }
    }
  }
}
</style>






// WEBPACK FOOTER //
// src/components/client/storesNumbers.vue